const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        resetDirtyFieldsAfterSuccessfulSubmit: false,
        forceDirty: true,
        onSubmitDonePanelMessage: 'status.done.processed'
    },

    methods: {
        async customSubmit(body){
            if(this.model.uploader){
                await this.model.uploader.start(((body || {}).data || {}).attributes || {})

                return {
                    response: {}
                }
            }
            this.performAction(
                this.prepareAction('message', undefined, {
                    messageDisplay: {
                        message: 'error:mblx.reports.missingUploader'
                    }
                }, {
                    statusControllerLoadingMessage: '',
                    statusControllerSavingMessage:  ''
                })
            )

            return {
                response: {}
            }
        }
    },

    hooks: {
        _attach: function($element, options){
            var self = this;

            if(!self.model.uploader){
                self.find('templates_mblx_reports_uploader', function(uploader){
                    self.model.uploader = uploader
                })
            }
        }
    }
}